/**
 * The pages where the app never reloads itself.
 *
 * Aran, 2026-10-14: "make sure /admin/word-flags doesn't refresh when I'm
 * actually working on it." An admin is mid-decision there — a row open, half a
 * correction typed — and staging gets many deploys a day. The update machinery
 * (resume auto-apply, auto-apply once downloaded, the open-screen hold, the
 * stale-chunk reload) reloads the page by itself, which throws all of that
 * away. On these pages a new build is downloaded quietly and offered through
 * the update banner ("Restart now"); only a tap on it ever reloads.
 *
 * /admin and /intel share one shell (AdminContainer), so one prefix test
 * covers every page in it. /review is a volunteer's copy of the same flag queue
 * (job #660), mid-decision in exactly the same way.
 */
export function inNoReloadZone(pathname?: string): boolean {
  const p = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '')
  return /^\/(admin|intel|review)(\/|$)/.test(p)
}
